import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationPipe } from './translation.pipe/translation.pipe';
import { NgPipesModule } from 'ngx-pipes';

@NgModule({
  declarations: [
    TranslationPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TranslationPipe,
    NgPipesModule
  ]
})
export class PipeModule { }
